import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://czsxtuhnzcxtdmfsrxun.supabase.co'
const supabaseKey = 'sb_publishable_SYqiaSTSZ51PO-9b_Vi3zQ_VHNiEtgq'

export const supabase = createClient(supabaseUrl, supabaseKey)